var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgPlay = function SvgPlay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E469D1",
    d: "M0 0h50v50H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.94 23.33l-10.021-5.962a2.738 2.738 0 00-2.743 0A2.194 2.194 0 0018 19.216v11.98a2.195 2.195 0 001.164 1.903 2.732 2.732 0 002.755-.056l10.02-5.962a2.183 2.183 0 000-3.745v-.006z",
    fill: "#fff"
  })));
};

export default SvgPlay;